module.exports = __webpack_public_path__ + "img/b-campus-wh.d88238c0.svg";